import './Init.css';

const Init = () => {
  return (
    <div className="init">
      <div className="init-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default Init;
